<template>
  <el-scrollbar class="components-attr-edit">
    <div
      class="attr-edit-inner"
      v-if="activeElementGroupUUID || activeElementUUIDMore.length > 1"
    >
      <div
        class="name-style"
        v-if="
          activeElementGroupUUID &&
          activePage.elementGroups.find((i) => i.uuid == activeElementGroupUUID)
        "
      >
        <div class="attr-title marginB10 fontBold">多个元件</div>
        <el-form @submit.native.prevent="() => {}">
          <el-form-item label="元件组名">
            <el-input
              v-model="activeElementGroup.groupName"
              @input="manageRefresh"
              placeholder="请输入元件组名"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="name-style" v-if="!activeElementGroupUUID">
        <div class="attr-title marginB10 fontBold">多个元件</div>
        <el-form>
          <el-form-item>
            <el-button type="primary" round @click.stop.prevent="createGroup"
              >组合元件</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div
        class="attr-item-edit-wrapper marginB15"
        v-if="!activeElementGroupUUID"
      >
        <p class="attr-item-title">快捷排列：</p>
        <div class="sizeAndPosition-wrapper">
          <div
            class="align-type-item"
            v-for="item in arrangeAlignTypeList"
            :key="item.type"
            @click="changeArrangeAlignType(item.type)"
          >
            <el-tooltip effect="dark" :content="item.title" placement="bottom">
              <i :class="[item.icon]"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="attr-title marginB10 fontBold" v-if="activeElementGroupUUID">
        基础样式：
      </div>
      <div
        class="attr-item-edit-wrapper marginB15"
        v-if="activeElementGroupUUID"
      >
        <div class="sizeAndPosition-wrapper">
          <p class="attr-item-title">是否显示：</p>
          <el-checkbox
            v-model="activeElementGroup.display"
            true-label="block"
            false-label="none"
          ></el-checkbox>
        </div>
      </div>
      <div class="attr-item-edit-wrapper" v-if="activeElementGroupUUID">
        <p class="attr-item-title">旋转：</p>
        <div class="col-1 attr-item-edit-input">
          <el-slider
            v-model="activeElementGroup.rotate"
            @change="throttleAddHistory"
            show-input
            :min="-180"
            :max="180"
            :marks="{ 0: '', 90: '', '-90': '' }"
            input-size="mini"
          ></el-slider>
        </div>
      </div>
      <div
        class="attr-item-edit-wrapper marginB15"
        v-if="activeElementGroupUUID"
      >
        <p class="attr-item-title">快捷定位：</p>
        <div class="sizeAndPosition-wrapper">
          <div
            class="align-type-item"
            v-for="item in alignTypeList"
            :key="item.type"
            @click="changeAlignType(item.type)"
          >
            <el-tooltip effect="dark" :content="item.title" placement="bottom">
              <i :class="[item.icon]"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="attr-item-edit-wrapper" v-if="activeElementGroupUUID">
        <p class="attr-item-title">快捷resize：</p>
        <div class="sizeAndPosition-wrapper">
          <div
            class="align-type-item clearFlex"
            @click="handleResizeClick('wh')"
          >
            <el-tooltip effect="dark" content="满屏" placement="bottom">
              <i class="iconfont iconquanping"></i>
            </el-tooltip>
          </div>
          <div
            class="align-type-item clearFlex"
            @click="handleResizeClick('w')"
          >
            <el-tooltip effect="dark" content="宽100%" placement="bottom">
              <i class="iconfont iconcolumn-width"></i>
            </el-tooltip>
          </div>
          <div
            class="align-type-item clearFlex"
            @click="handleResizeClick('h')"
          >
            <el-tooltip effect="dark" content="高100%" placement="bottom">
              <i class="iconfont iconcolum-height"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div
        class="name-style"
        :style="{ marginTop: '20px' }"
        v-if="activeElementGroupUUID"
      >
        <el-form>
          <el-form-item>
            <el-button type="primary" round @click.stop.prevent="cancelGroup"
              >取消组合元件</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="props-attr-style">
        <propsAttr></propsAttr>
      </div>
      <div class="common-attr-style">
        <baseAttr></baseAttr>
      </div> -->
    </div>
  </el-scrollbar>
</template>

<script>
// import baseAttr from './attr-props-components/base-attr'
// import propsAttr from './attr-props-components/props-attr/index.vue'
import { mapState, mapGetters } from "vuex";
import { ceil, subtract, divide } from "lodash";

export default {
  props: {},
  components: {
    // baseAttr,
    // propsAttr
  },
  data() {
    return {
      rotate: 0,
      arrangeAlignTypeList: [
        {
          title: "水平居中",
          icon: "iconfont iconshuipingjuzhongduiqi",
          type: "horizontally",
        },
        {
          title: "水平排列",
          icon: "iconfont iconshuipingjuzhongduiqi",
          type: "horizontalArrangement",
        },
        {
          title: "垂直居中",
          icon: "iconfont iconchuizhijuzhongduiqi",
          type: "lr",
        },
        {
          title: "垂直排列",
          icon: "iconfont iconchuizhijuzhongduiqi",
          type: "tb",
        },
        {
          title: "左对齐",
          icon: "iconfont iconzuoduiqi",
          type: "l",
        },
        {
          title: "上对齐",
          icon: "iconfont iconshangduiqi",
          type: "t",
        },
        {
          title: "右对齐",
          icon: "iconfont iconyouduiqi",
          type: "r",
        },
        {
          title: "下对齐",
          icon: "iconfont iconxiaduiqi",
          type: "b",
        },
      ],
      alignTypeList: [
        {
          title: "左对齐",
          icon: "iconfont iconzuoduiqi",
          type: "l",
        },
        {
          title: "上对齐",
          icon: "iconfont iconshangduiqi",
          type: "t",
        },
        {
          title: "右对齐",
          icon: "iconfont iconyouduiqi",
          type: "r",
        },
        {
          title: "下对齐",
          icon: "iconfont iconxiaduiqi",
          type: "b",
        },
        {
          title: "垂直居中对齐",
          icon: "iconfont iconchuizhijuzhongduiqi",
          type: "tb",
        },
        {
          title: "水平居中对齐",
          icon: "iconfont iconshuipingjuzhongduiqi",
          type: "lr",
        },
      ],
    };
  },
  watch: {
    "activeElementGroup.rotate": function (val) {
      this.activeElementGroup.relativeData &&
        this.activeElementGroup.relativeData.map((i) => {
          const elemIndex = this.activePage.elements.findIndex(
            (m) => m.uuid == i.uuid
          );
          this.activePage.elements[
            elemIndex
          ].commonStyle.rotateOrigin = `${i.rotateX}% ${i.rotateY}%`;
          this.activePage.elements[elemIndex].commonStyle.rotate = val;
        });
    },
  },
  computed: {
    ...mapState({
      projectData: (state) => state.editor.projectData,
      activePageUUID: (state) => state.editor.activePageUUID,
      activeElementUUID: (state) => state.editor.activeElementUUID,
      activeElementUUIDMore: (state) => state.editor.activeElementUUIDMore,
      activeElementGroupUUID: (state) => state.editor.activeElementGroupUUID,
    }),
    ...mapGetters([
      "currentPageIndex",
      "activeElementIndex",
      "activeElement",
      "activePage",
      "activeElementGroup",
    ]),
  },
  methods: {
    manageRefresh() {
      this.$emit("manageRefresh");
    },
    throttleAddHistory() {
      this.$store.dispatch("addHistoryCache");
    },
    createGroup() {
      this.$emit("createGroup");
    },
    cancelGroup() {
      this.$emit("cancelGroup");
    },
    handleResizeClick(type) {
      if (type.includes("w")) {
        this.activeElementGroup.relativeData.map((i) => {
          const elemIndex = this.activePage.elements.findIndex(
            (m) => m.uuid == i.uuid
          );
          this.activePage.elements[elemIndex].commonStyle.width =
            this.projectData.width * i.width;
          this.activePage.elements[elemIndex].commonStyle.left =
            0 + this.projectData.width * i.left;
        });
      }
      if (type.includes("h")) {
        this.activeElementGroup.relativeData.map((i) => {
          const elemIndex = this.activePage.elements.findIndex(
            (m) => m.uuid == i.uuid
          );
          this.activePage.elements[elemIndex].commonStyle.top =
            0 + this.projectData.height * i.top;
          this.activePage.elements[elemIndex].commonStyle.height =
            this.projectData.height * i.height;
        });
      }
      this.$store.dispatch("addHistoryCache");
    },
    changeArrangeAlignType(type){
      const activeElements = this.activeElementUUIDMore.map((i)=>this.activePage.elements.find((m)=>m.uuid == i));
      const { top, left, width, height } = activeElements[0].commonStyle;
      let minTop = 9999, maxTop = 0, minLeft = 9999, maxLeft = 0, totalHeight = 0, totalWidth = 0, distance = 0, topWithDistance = 0, leftWithDistance = 0, middleLeft = 0, middleTop = 0;
      console.log(activeElements, 'changeArrangeAlignType')
      switch (type) {
        case "horizontally":
          // 水平居中
          middleTop = activeElements[0].commonStyle.top + (activeElements[0].commonStyle.height / 2)
          activeElements.map((i, k)=>{
            if(k > 0){
              const elementIndex = this.activePage.elements.findIndex((m)=>m.uuid == i.uuid)
              this.activePage.elements[elementIndex].commonStyle.top = middleTop - (i.commonStyle.height / 2);
            }
          })
          break;
        case "horizontalArrangement":
          // 水平排列
          activeElements.map((i)=>{
            i.commonStyle.left < minLeft && (minLeft = i.commonStyle.left);
            i.commonStyle.left + i.commonStyle.width > maxLeft && (maxLeft = i.commonStyle.left + i.commonStyle.width);
            totalWidth += i.commonStyle.width;
          })
          if(maxLeft - minLeft > totalWidth){
            // 存在距离
            distance = (maxLeft - minLeft - totalWidth) / (activeElements.length - 1);
            activeElements.sort((a, b) => a.commonStyle.left - b.commonStyle.left).map((i, k)=>{
              const elementIndex = this.activePage.elements.findIndex((m)=>m.uuid == i.uuid)
              k < 1 && (leftWithDistance = i.commonStyle.left);
              this.activePage.elements[elementIndex].commonStyle.left = leftWithDistance;
              leftWithDistance += i.commonStyle.width + distance;
            })
          }
          break;
        case "tb":
          // 垂直排列
          activeElements.map((i)=>{
            i.commonStyle.top < minTop && (minTop = i.commonStyle.top);
            i.commonStyle.top + i.commonStyle.height > maxTop && (maxTop = i.commonStyle.top + i.commonStyle.height);
            totalHeight += i.commonStyle.height;
          })
          if(maxTop - minTop > totalHeight){
            // 存在距离
            distance = (maxTop - minTop - totalHeight) / (activeElements.length - 1);
            activeElements.sort((a, b) => a.commonStyle.top - b.commonStyle.top).map((i, k)=>{
              const elementIndex = this.activePage.elements.findIndex((m)=>m.uuid == i.uuid)
              k < 1 && (topWithDistance = i.commonStyle.top);
              this.activePage.elements[elementIndex].commonStyle.top = topWithDistance;
              topWithDistance += i.commonStyle.height + distance;
            })
          }
          break;
        case "lr":
          // 垂直居中
          middleLeft = activeElements[0].commonStyle.left + (activeElements[0].commonStyle.width / 2)
          activeElements.map((i, k)=>{
            if(k > 0){
              const elementIndex = this.activePage.elements.findIndex((m)=>m.uuid == i.uuid)
              this.activePage.elements[elementIndex].commonStyle.left = middleLeft - (i.commonStyle.width / 2);
            }
          })
          break;
        case "t":
          // 上对齐
          activeElements.map((i, k)=>{
            if(k > 0){
              const elementIndex = this.activePage.elements.findIndex((m)=>m.uuid == i.uuid)
              this.activePage.elements[elementIndex].commonStyle.top = top;
            }
          })
          break;
        case "b":
          // 下对齐
          activeElements.map((i, k)=>{
            if(k > 0){
              const elementIndex = this.activePage.elements.findIndex((m)=>m.uuid == i.uuid)
              this.activePage.elements[elementIndex].commonStyle.top = top + height - this.activePage.elements[elementIndex].commonStyle.height;
            }
          })
          break;
        case "l":
          // 左对齐
          activeElements.map((i, k)=>{
            if(k > 0){
              const elementIndex = this.activePage.elements.findIndex((m)=>m.uuid == i.uuid)
              this.activePage.elements[elementIndex].commonStyle.left = left;
            }
          })
          break;
        case "r":
          // 右对齐
          activeElements.map((i, k)=>{
            if(k > 0){
              const elementIndex = this.activePage.elements.findIndex((m)=>m.uuid == i.uuid)
              this.activePage.elements[elementIndex].commonStyle.left = left + width - this.activePage.elements[elementIndex].commonStyle.width;
            }
          })
          break;
      }
    },
    changeAlignType(type) {
      let canvasW = this.projectData.width;
      let canvasH = this.projectData.height;
      const defaultStyle = this.activeElementGroup.defaultStyle;
      switch (type) {
        case "t":
          // 上对齐
          this.activeElementGroup.relativeData.map((i) => {
            const elemIndex = this.activePage.elements.findIndex(
              (m) => m.uuid == i.uuid
            );
            this.activePage.elements[elemIndex].commonStyle.top =
              0 + defaultStyle.height * i.top;
          });
          break;
        case "b":
          // 下对齐
          this.activeElementGroup.relativeData.map((i) => {
            const elemIndex = this.activePage.elements.findIndex(
              (m) => m.uuid == i.uuid
            );
            this.activePage.elements[elemIndex].commonStyle.top =
              subtract(canvasH - defaultStyle.height) +
              defaultStyle.height * i.top;
          });
          break;
        case "l":
          // 左对齐
          this.activeElementGroup.relativeData.map((i) => {
            const elemIndex = this.activePage.elements.findIndex(
              (m) => m.uuid == i.uuid
            );
            this.activePage.elements[elemIndex].commonStyle.left =
              0 + defaultStyle.width * i.left;
          });
          break;
        case "r":
          // 右对齐
          this.activeElementGroup.relativeData.map((i) => {
            const elemIndex = this.activePage.elements.findIndex(
              (m) => m.uuid == i.uuid
            );
            this.activePage.elements[elemIndex].commonStyle.left =
              subtract(canvasW - defaultStyle.width) +
              defaultStyle.width * i.left;
          });
          break;
        case "tb":
          // 垂直居中对齐
          this.activeElementGroup.relativeData.map((i) => {
            const elemIndex = this.activePage.elements.findIndex(
              (m) => m.uuid == i.uuid
            );
            this.activePage.elements[elemIndex].commonStyle.top =
              ceil(divide(subtract(canvasH - defaultStyle.height), 2), 2) +
              defaultStyle.height * i.top;
          });
          break;
        case "lr":
          // 水平居中对齐
          this.activeElementGroup.relativeData.map((i) => {
            const elemIndex = this.activePage.elements.findIndex(
              (m) => m.uuid == i.uuid
            );
            this.activePage.elements[elemIndex].commonStyle.left =
              ceil(divide(subtract(canvasW - defaultStyle.width), 2), 2) +
              defaultStyle.width * i.left;
          });
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.components-attr-edit {
  height: 100%;
}

.attr-title {
  font-weight: bold;
}
.sizeAndPosition-wrapper {
  display: flex;
  width: 100%;
  margin-top: 10px;
}

.align-type-item {
  flex: 1;
  cursor: pointer;
  text-align: center;
  &.clearFlex {
    width: 42px;
    flex: none;
  }
  i {
    line-height: 1;
    display: inline-block;
    padding: 6px;
    border-radius: 4px;
    background: rgba(37, 165, 137, 0.08);
  }
  &:hover {
    i {
      color: white;
      background: $primary;
    }
  }
  &.no-flex {
    flex: 0;
    margin-right: 10px;
  }
}
</style>
<style lang="scss">
.common-attr-style {
  .el-form-item {
    margin-bottom: 0;
  }
}
</style>
